import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';

import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  CircularProgress,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// components

import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/user';
import { DeleteVacancies, GetVacanciesList } from 'src/components/services/httpServices';
import { useNavigate } from 'react-router-dom';
import RecrutmentListToolbar from 'src/sections/@dashboard/recruitment/RecrutmentListToolbar';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'Sr', alignRight: false },
  { id: 'vacancyName', label: 'Vacancy Name', alignRight: false },
  { id: 'vacancyType', label: 'Vacancy Type', alignRight: false },
  { id: 'positionName', label: 'Position Name', alignRight: false },
  { id: 'noOfVac', label: 'No of Positions', alignRight: false },
  { id: 'mstCompanyName', label: 'Company Name', alignRight: false },
  // { id: '' },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    let sorted = [];
    sorted = array
      .map((_user) => {
        const vacancyNameMatch = _user?.vacancyName?.toLowerCase().indexOf(query.toLowerCase()) !== -1;
        const positionNameMatch = _user?.positionName ? _user?.positionName?.includes(query) : false;
        const mstCompanyNameMatch = _user?.mstCompanyName ? _user?.mstCompanyName?.includes(query) : false;
        const vacancyTypeMatch = _user?.vacancyType
          ? _user?.vacancyType?.toLowerCase().includes(query.toLowerCase())
          : false;

        // Assign weights based on matching criteria
        const weights = {
          vacancyName: vacancyNameMatch ? 4 : 0,
          mstCompanyName: mstCompanyNameMatch ? 3 : 0,
          positionName: positionNameMatch ? 2 : 0,
          vacancyType: vacancyTypeMatch ? 1 : 0,
        };

        // Calculate total weight
        const totalWeight = Object.values(weights).reduce((sum, weight) => sum + weight, 0);

        return { user: _user, totalWeight };
      })
      .filter((obj) => obj.totalWeight > 0)
      .sort((a, b) => b.totalWeight - a.totalWeight)
      .map((obj) => obj.user);

    return sorted;
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function VacanciesList() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [vacanciesList, setVacanciesList] = useState([]);
  const [message, setMessage] = useState('');
  const [saved, setSaved] = useState(false);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(
    () => {
      const fetch = async () => {
        const response = await GetVacanciesList();
        if (response !== null) {
          setVacanciesList(response);
          setLoading(false);
          // setNotificationCount(response.data.length);

          //        console.log('UsersLit', response);
        }
      };
      fetch();
    },
    []
    // [pr],
    // [pr?.prQ1Collection]
  );
  const rowClicked = async (row) => {
    setSelectedRow(row);
  };
  const deleteVacancyList = async (selectedUsersList) => {
    const payload = {
      ids: selected,
    };

    //  console.log(payload);
    let response = await DeleteVacancies(payload);
    //   console.log('PostResponse:', response);

    if (response.status == 200) {
      const isSelected = (user) => {
        let check = selected.includes(user.id);
        return !check;
      };
      const list = vacanciesList.filter((e) => {
        if (isSelected(e)) {
          return e;
        }
      });
      //    console.log('Users:', list);
      setVacanciesList(list);
      setSelected([]);
      setMessage(response.data);
      setSaved(true);
      setOpenMessage(true);
      // setTimeout(() => {
      //   navigate('/app/user');
      // }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpenMessage(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  const handleEdit = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/EditVacancy/${selectedRow.id}`);
  };
  const handleDetails = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/VacancyDetails/${selectedRow.id}`);
  };
  const handelCreateVacancy = () => {
    navigate('/app/CreateVacancy');
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = vacanciesList.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const handleClickVacancy = (row) => {
    navigate(`/app/VacancyTabsPage/${row.id}`);
  };
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - vacanciesList.length) : 0;

  const filteredUsers = applySortFilter(vacanciesList, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Jobs | Immigration System </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Jobs
          </Typography>
          <Button variant="contained" onClick={handelCreateVacancy} startIcon={<Iconify icon="eva:plus-fill" />}>
            Add
          </Button>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Card>
            <RecrutmentListToolbar
              numSelected={selected.length}
              selectedUsers={selected}
              setSelected={setSelected}
              filterName={filterName}
              onFilterName={handleFilterByName}
              deleteUsers={deleteVacancyList}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={vacanciesList.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                      {
                        /* const { id, name, role, status, company, userEmail } = row; */
                      }
                      const { id, vacancyName, vacancyType, noOfVac, positionName, mstCompanyName } = row;
                      const selectedCompany = selected.indexOf(id) !== -1;

                      return (
                        <TableRow
                          hover
                          key={index + 1}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedCompany}
                          onClick={() => rowClicked(row)}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedCompany} onChange={(event) => handleClick(event, id)} />
                          </TableCell>
                          {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {index + 1}
                              </Typography>
                            </Stack>
                          </TableCell> */}

                          <TableCell onClick={() => handleClickVacancy(row)} component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {vacancyName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleClickVacancy(row)} component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {vacancyType}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleClickVacancy(row)} component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {positionName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleClickVacancy(row)} component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {noOfVac}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleClickVacancy(row)} component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {mstCompanyName}
                              </Typography>
                            </Stack>
                          </TableCell>

                          {/* <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={vacanciesList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edits
        </MenuItem>
        <MenuItem onClick={handleDetails}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 2 }} />
          Details
        </MenuItem>
        {/* <MenuItem sx={{ color: 'error.main' }} onClick={}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem> */}
      </Popover>
    </>
  );
}
